const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import i18n from '@/lib/translations/i18n';
const paramsSchema = z.object({
  loopId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations')({
  params: paramsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('view_loop_visualization'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.visualizations)
    }
  }
});